import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@clerk/clerk-react';
import LoadingBar from '../components/Reusable/LoadingBar';
import { PATH_AUTH } from 'src/routes/paths';

// Clerk-backed AuthGuard. Replaces the prior Cognito-driven implementation
// 2026-04-20. ProtectedRoute / OrgGuard / etc. callers don't need to
// change — they still wrap children in <AuthGuard>.
//
// Profile loading isn't gated here anymore; profile fetch happens lazily
// from useProfile() hooks downstream. The previous AuthGuard blocked
// rendering on profileLoading, but that introduced a flash of LoadingBar
// on every page nav even when the profile was already cached. With
// Clerk's instant `isSignedIn` we just gate on session presence.
type AuthGuardProps = { children: ReactNode };

export default function AuthGuard({ children }: AuthGuardProps) {
  const { isLoaded, isSignedIn } = useAuth();
  const { pathname } = useLocation();

  if (!isLoaded) {
    return (
      <div className="fixed inset-0 bg-[#181818] flex items-center justify-center">
        <LoadingBar />
      </div>
    );
  }

  if (!isSignedIn) {
    return <Navigate to={PATH_AUTH.login} replace state={{ from: pathname }} />;
  }

  return <>{children}</>;
}
